export default "__VITE_ASSET___ve3aLFx__"